module.exports = __webpack_public_path__ + "img/bate-papo.ccc56bd6.svg";